module.exports = __webpack_public_path__ + "img/pro_night_2.9fec6d6b.jpg";